import React from "react";

import { Box, Button } from "@mui/material";

import { MaterialReactTable } from "material-react-table";

import { useFormContext, useWatch } from "react-hook-form";

import {
  compactTableProps,
  smallerHeadCellProps,
} from "../../../../../../styles/muiProps";

import { estimationColumns } from "./columnsData/columns";

import { createShellTasks } from "../../../../../../api/tasksApi";

import {
  useResponsiveShellTable,
  getResponsiveShellTableConfig,
} from "./responsiveShellTable";

// Edge Mentor code labels for the Shell Estimation table (DataGridView7).
// These semantic labels match the Edge Mentor Excel/runtime content.
const SHELL_ESTIMATION_EDGE_MENTOR_CODE_LABELS = {
  Circ_Weld_Hours: "shellEstCircWeldHours",
  Long_Weld_Hours: "shellEstLongWeldHours",
  Rolling_Hours: "shellEstRollingHours",
  Dishing_Hours: "shellEstDishingHours",
  NDT_Cost: "shellEstNdtCost",
};

const ESTIMATION_COLUMN_WEIGHTS = {
  Circ_Weld_Hours: 1,
  Long_Weld_Hours: 1,
  Rolling_Hours: 1,
  Dishing_Hours: 1,
  NDT_Cost: 1,
};

const EstimationTable = (props) => {
  const { isLoading, projectId, equipId } = props;
  const { control, getValues } = useFormContext();
  const watchedRows = useWatch({
    control,
    name: "DataGridView7",
  });

  const addToTasks = async () => {
    const inputRaw = getValues("DataGridView5");
    const estimation = getValues("DataGridView7");
    // Strip UID before sending to tasks API
    const input = inputRaw?.map((row) => {
      const { UID, ...rest } = row;
      return rest;
    });
    let subCategoryRequest = {
      subCategory: {
        name: "",
        estimatedHours: 0,
        remarks: "",
        invoiceable: false,
        // categoryId: row.id
      },
      users: [],
    };
    console.log(input);
    let categoryRequest = {
      name: "Shell Welding",
      mcsProjectId: projectId,
      // tasks: data
    };

    await createShellTasks(input, estimation, projectId, equipId);
  };

  const {
    viewportRef,
    tableWidth,
    headerFontSize,
    bodyFontSize,
    columns: responsiveColumns,
  } = useResponsiveShellTable(
    estimationColumns ?? [],
    ESTIMATION_COLUMN_WEIGHTS,
  );

  const { mrtProps, headCellSx, bodyCellSx } = getResponsiveShellTableConfig({
    tableWidth,
    headerFontSize,
    bodyFontSize,
  });

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",

        overflowX: "hidden",
      }}
    >
      <MaterialReactTable
        {...compactTableProps}
        {...smallerHeadCellProps}
        {...mrtProps}
        columns={responsiveColumns ?? []}
        data={watchedRows ?? []}
        enableEditing
        editDisplayMode="cell"
        enableSorting={false}
        enableColumnActions={false}
        enableTopToolbar={false}
        state={{
          isLoading,
        }}
        muiTableHeadCellProps={{
          sx: headCellSx,
        }}
        muiTableBodyCellProps={({ cell }) => ({
          "data-edge-mentor":
            SHELL_ESTIMATION_EDGE_MENTOR_CODE_LABELS[cell.column.id] ||
            undefined,

          sx: {
            ...bodyCellSx,

            textAlign: "center !important",
            justifyContent: "center !important",

            "& .Mui-TableBodyCell-Content-Wrapper": {
              ...(bodyCellSx["& .Mui-TableBodyCell-Content-Wrapper"] || {}),

              width: "100%",
              justifyContent: "center !important",
              textAlign: "center !important",
            },

            "& .MuiInputBase-root": {
              width: "100%",
              textAlign: "center",
            },

            "& .MuiInputBase-input": {
              textAlign: "center !important",
            },
          },
        })}
        /*
         * Keep the business action, but move it away
         * from the removed MRT top toolbar.
         */
        renderBottomToolbarCustomActions={() => (
          <Button
            color="primary"
            onClick={() => addToTasks()}
            variant="contained"
            size="small"
          >
            Add to Tasks
          </Button>
        )}
      />
    </Box>
  );
};

export default EstimationTable;
